import dynamic from 'next/dynamic';

const PartnersGrid = dynamic(() => import('./PartnersGrid/PartnersGrid'));
const AddPartner = dynamic(() => import('./AddPartner/AddPartner'));
const PartnerModalForm = dynamic(() =>
  import('./PartnerModalForm/AddEditPartnerForm')
);

export { PartnersGrid, PartnerModalForm, AddPartner };
